import { Service } from '@/types/service';
import { ServiceGroup } from '@/types/serviceGroup';
import { api } from '@/services/api/axios/instance';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

type GetParams = {
  data: {
    serviceGroupId: number;
  };
};

export const serviceGroupsApi = {
  getList: async (): Promise<ServiceGroup[]> => {
    const path = 'service_groups';
    const response: AxiosResponse<{
      serviceGroups: ServiceGroup[];
    }> = await api.get(path);

    return response.data.serviceGroups;
  },
  getDetail: async (
    id: number,
    config: AxiosRequestConfig,
  ): Promise<ServiceGroup> => {
    try {
      const path = `/service_groups/${id}`;
      const response: AxiosResponse<{
        serviceGroup: ServiceGroup;
      }> = await api.get(path, config);
      return response.data.serviceGroup;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  get: async (config: GetParams): Promise<Service[]> => {
    const { serviceGroupId } = config.data;
    const path = `/service_groups/${serviceGroupId}/services`;
    const response: AxiosResponse<{
      services: Service[];
    }> = await api.get(path, config);

    return response.data.services;
  },
};
